import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { SdmPaginatorV5 } from 'components/SdmPaginatorV5';
import { LoaderContext } from 'context/LoaderContextProvider';
import { LoaderCountContext } from 'context/LoaderV5';
import React, { useState } from 'react';
import { useContext } from 'react';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useNetwork } from 'services/network';
import translations from 'utils/translations';
import { ExhibitorCard, updateQueryParams } from '../common';
import { isQueryFiltersActive } from 'utils/constants';
import { usePaginationStore } from '../store/paginationStore';
import { setVirtualPageView } from 'utils/dataLayerManager';

const ExhibitorsList = ({
  queryParams,
  nations,
  exhibitions,
  openRegisterDialog,
  locale,
  loggedUser,
  navigateExhibitorDetail,
  isBiennali = false,
}) => {
  //Hooks
  const intl = useIntl();
  const i18nLegacy = translations.ExhibitorsList(intl).page;
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isXsDown = useMediaQuery(theme.breakpoints.down('xs'));
  const { isLoaderActive, setLoaderActive } = useContext(LoaderCountContext);
  const {
    isLoaderActive: isLegacyLoaderActive,
    setLoaderActive: setLegacyLoaderActive,
  } = useContext(LoaderContext);
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);
  const hideLegacyLoader = () => setLegacyLoaderActive(false);
  const network = useNetwork();
  const [prevUrl, nextUrl, totalPages, startPage] = usePaginationStore(
    (state) => [state.prevUrl, state.nextUrl, state.totalPages, state.startPage]
  );
  // States

  const [activeExhibitors, setActiveExhibitors] = useState();

  useEffect(() => {
    //se cambia queryUrl è cambiato il filtro, ricomincio dalla prima pagina
    if (queryParams) {
      fetchData(queryParams, true);
    }
  }, [queryParams]);

  const fetchData = async (params, loader = false) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    if (isQueryFiltersActive) {
      const url = new URL(window.location.href);
      updateQueryParams({ filterUrlQuery: params, url, isBiennali });
    }
    isLegacyLoaderActive && hideLegacyLoader();
    !isLoaderActive && loader && showLoader();
    const data = await network.exhibitorSearch(params);
    setVirtualPageView({
      params: `?${params}`,
      pageTitle: 'exhibitors filter',
    });
    // setLikeAll(undefined);
    usePaginationStore.setState({
      totalPages: data.totalPages,
      nextUrl: data.nextPage?.split('?')?.[1],
      prevUrl: data.previousPage?.split('?')?.[1],
      startPage: data.pageNumber || 0,
    });

    const exhibitors =
      data.data?.map((e) => ({
        name: e.nomeEspositore,
        provincia: e.provinciaSigla,
        indirizzo: e.indirizzo,
        comune: e.comune,
        email: e.email,
        cap: e.cap,
        appuntamenti: e.appuntamenti || false,
        prenotazioneAppuntamenti: e.prenotazioneAppuntamenti || false,
        emailDigitale: e.emailDigitale || e.email,
        percorsiTematici: e.percorsiTematici,
        categorie_en: e.categorieE,
        categorie_it: e.categorieI,
        prodotti_en: e.prodottiE,
        prodotti_it: e.prodottiI,
        phone: e.telefono,
        fax: e.fax,
        website: e.sitoInternet,
        hall: e.hall,
        stand: e.stand,
        erpid: e.erpId,
        nation: nations.find((n) => n.isoCode === e.nazioneIso3AlphaCode)
          ?.label,
        event:
          e.evento
            ?.split('|')
            .map(
              (evento) =>
                exhibitions.find((ex) => ex.code === evento)?.label ||
                i18nLegacy.notAvailable
            )
            .join(', ') || '',
        salesforceId: e.accountId,
        linkedAccountId: e.linkedAccountId,
      })) || [];
    setActiveExhibitors(exhibitors);
    hideLoader();
  };

  const handlePreviousPage = async () => {
    await fetchData(prevUrl);
  };

  const handleNextPage = async () => {
    await fetchData(nextUrl);
  };

  const handlePageChange = async ({ page, type }) => {
    const str = isQueryFiltersActive
      ? `${queryParams.replace(/&pageNumber=\d+/, '')}&pageNumber=${page}`
      : `${queryParams}&pageNumber=${page}`;
    switch (type) {
      case 'next':
        handleNextPage();
        break;
      case 'previous':
        handlePreviousPage();
        break;
      default:
        await fetchData(str);
        break;
    }
  };

  return (
    <Stack gap={'25px'} width={'100%'} component={'ul'}>
      {!isLoaderActive && queryParams && activeExhibitors && (
        <>
          {activeExhibitors.length > 0 ? (
            activeExhibitors.map((exhibitor, idx) => (
              <ExhibitorCard
                key={idx}
                exhibitor={exhibitor}
                openRegisterDialog={openRegisterDialog}
                locale={locale}
                loggedUser={loggedUser}
                navigateExhibitorDetail={navigateExhibitorDetail}
              />
            ))
          ) : (
            <Typography
              variant={'xl'}
              textAlign={'center'}
              style={{
                marginTop: 50,
                width: '100%',
                color: theme.palette.primary.main,
              }}
            >
              {i18nLegacy.notAvailableEx}
            </Typography>
          )}
          <Stack
            width={'100%'}
            alignItems={'center'}
            justifyContent={'center'}
            component={'li'}
          >
            {activeExhibitors.length > 0 && (
              <SdmPaginatorV5
                totalPages={totalPages}
                i18n={i18nLegacy}
                callBackFunction={handlePageChange}
                isSmDown={isSmDown}
                isXsDown={isXsDown}
                startPage={startPage}
              />
            )}
          </Stack>
        </>
      )}
    </Stack>
  );
};
export default ExhibitorsList;
